"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ContactLabels = require("./ContactLabels");
Object.keys(_ContactLabels).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ContactLabels[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ContactLabels[key];
    }
  });
});